import { Globe } from 'lucide-react';
import { Language } from '../../../types/matching';

interface ProfileLanguagesProps {
  languages: Language[];
}

const LEVEL_CONFIG: Record<string, { label: string; color: string }> = {
  native: { label: 'Natif', color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300' },
  fluent: { label: 'Courant', color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300' },
  intermediate: { label: 'Intermediaire', color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300' },
  basic: { label: 'Basique', color: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400' },
};

export function ProfileLanguages({ languages }: ProfileLanguagesProps) {
  if (!languages || languages.length === 0) return null;

  return (
    <div>
      <div className="flex items-center gap-2.5 mb-4">
        <Globe className="w-5 h-5 text-gray-400 dark:text-gray-500" />
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Langues</h3>
      </div>
      <div className="flex flex-wrap gap-2.5">
        {languages.map((lang) => {
          const level = LEVEL_CONFIG[lang.level] || LEVEL_CONFIG.basic;
          return (
            <div
              key={lang.code}
              className="flex items-center gap-2.5 px-4 py-2.5 rounded-xl bg-gray-50 dark:bg-gray-700/30 border border-gray-100 dark:border-gray-700/50"
            >
              <span className="text-sm font-semibold text-gray-900 dark:text-white">{lang.name}</span>
              <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-md ${level.color}`}>
                {level.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
